import React from 'react';
import { Container, Nav, Tab } from 'react-bootstrap';
import education from './education.json';
import work from './workExperience.json' ;
import TimelineComponent from './Qualifications';
const WorkEducation = () => {
  return (
    <Container className='workExperience' style={{ width: '60%' }}>
      <b id='skills' style={{fontSize:'2rem'}}><box-icon name='visual-studio' type='logo' animation='flashing' size='md'></box-icon> Work & Education</b>
      <p style={{ color: 'gray', fontWeight: 'bold' }}>———————— Here's about my education ————————</p>
      <Tab.Container id="myTab" defaultActiveKey="home-tab">
        <Nav variant="tabs" fill>
          <Nav.Item>
            <Nav.Link eventKey="home-tab"><b><i class="uil uil-monitor-heart-rate"></i> Education </b></Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link eventKey="backEnd"><b><i class="uil uil-server"></i> Working </b> </Nav.Link>
          </Nav.Item>
        </Nav>
        <Tab.Content>
          <Tab.Pane eventKey="home-tab">
            <br />
            <TimelineComponent timelineData={education} />
          </Tab.Pane>

          <Tab.Pane eventKey="backEnd">
            <br />
            <TimelineComponent timelineData={work} />
          </Tab.Pane>
        </Tab.Content>
      </Tab.Container>
    </Container>
  );
};

export default WorkEducation;
